export { default as SomethingWentWrongPage } from './pages/SomethingWentWrongPage';
export { default as NotFoundPage } from './pages/NotFoundPage';


// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/ErrorPages/index.tsx